export const LISTE_REMISE = {
  title: 'Liste des libellés remise personnalisé',
  tab: {
    remise: 'Libellé remise',
    libelle: 'Description',
    isRemiseRegie: 'Remise régie',
  },
  actions: {
    add: 'Créer un libellé remise personnalisé',
    noResult: 'Aucun résultat',
  },
};

export const AJOUT_MODIFICATION_REMISE = {
  title: {
    add: 'Ajouter un libellé remise personnalisé',
    edit: 'Modifier un libellé remise personnalisé',
  },
  success: {
    add: 'Remise ajouté avec succès',
    edit: 'Remise modifié avec succès',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
    libelle: 'Remise',
    message: 'Description',
  },
  remise: 'Remise',
  description: 'Description',
  isRemiseRegie: 'Remise régie',
  actions: {
    cancel: 'Annuler',
  },
};

export const REMISE = {
  title: 'Remises',
  ligneVente: {
    remise: 'Remise',
    libelle: 'Libellé',
  },
  actions: {
    search: 'Recherche...',
    noResult: 'Aucun résultat',
  },
};
